import AlertRulePanel from './AlertRulePanel';

export default AlertRulePanel;
export { AlertRulePanel };
